import React, { useRef } from 'react'
import useOnClickOutside from 'srcReact/helpers/hooks/useOnClickOutside'
import OrganizationAvatar from 'srcReact/components/common/OrganizationAvatar'
import { getInitials, isNative } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import { useTranslation } from 'react-i18next'

const OrganizationSideBar = ({
  close,
  currentOrganization,
  isMobile,
  organizations,
  organizationAction,
  user_properties,
  ...rest
}) => {
  const { t } = useTranslation()
  const ref = useRef()
  useOnClickOutside(ref, close)

  const orgas = organizations
    .filter(({ resourceKey }) => resourceKey != currentOrganization.resourceKey)
    .map((orga) => {
      const { color, name, notificationsNumber, resourceKey } = orga
      return (
        <OrganizationAvatar
          key={resourceKey}
          color={color}
          notificationNumber={notificationsNumber}
          title={orga.accronym || getInitials(name)}
          fullOrgName={name}
          subTitle={name}
          onClick={() => {
            const isPreviewOpen = localStorage.getItem('mixr_preview')
            if (!isPreviewOpen) {
              organizationAction(orga, true)
            }
          }}
        />
      )
    })

  const handleKeyDown = (e) => {
    if (e.keyCode.toString() === '13') {
      close()
    }
  }

  return (
    <div className={`orga-sidebar ${isMobile && 'orga-sidebar--mobile'}`} ref={ref}>
      {isMobile && (
        <div className='orga-sidebar__close-mobile' onClick={close}>
          ›
        </div>
      )}
      <div className='orga-sidebar__close-web'>
        {!isMobile && (
          <div className='orga-sidebar__cross-icon' tabIndex='0' onKeyDown={handleKeyDown} onClick={close}>
            <Icon name='close' size='medium' alt={t('nav.closeSidebar')} />
          </div>
        )}
        <OrganizationAvatar
          fullOrgName={currentOrganization?.name}
          title={currentOrganization.accronym || getInitials(currentOrganization.name)}
          notificationNumber={currentOrganization && currentOrganization.notificationsNumber}
          isCurrentOrga={true}
          subTitle={currentOrganization?.name}
        />
      </div>
      <div className='orga-sidebar__separator' />
      <div className='orga-sidebar__orgas-list'>{orgas}</div>

      {!!user_properties?.organization?.with_creation && (
        <React.Fragment>
          <div className='orga-sidebar__separator' />
          <div className='orga-sidebar__add-orga'>
            <OrganizationAvatar
              addOrga={true}
              onClick={() => {
                redirectToPage(`/0/create-organization`, isNative())
              }}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default OrganizationSideBar
